const comicsApi = require('../api/comics');
const { updateLootcoinBalance } = require('./UserActions');
const { readComic: readComicAction } = require('../reducers/readComics');

const MIN_COMICS_UPDATE = 1000 * 60 * 5; // 5 minutes
const FETCH_COMICS_TIMEOUT = 1000 * 30; // 30 seconds

function fetchComicsInProgress() {
  return {
    type: 'FETCH_COMICS_IN_PROGRESS',
    timestamp: Date.now(),
  };
}

function fetchComicsSuccessful(comics) {
  return {
    type: 'FETCH_COMICS_SUCCESSFUL',
    comics,
    timestamp: Date.now(),
  };
}

function setOrder() {
  return {
    type: 'SETORDER',
  };
}

function fetchComicsFailed(reason) {
  return {
    type: 'FETCH_COMICS_FAILED',
    reason,
    timestamp: Date.now(),
  };
}

function invalidateComics() {
  return {
    type: 'INVALIDATE_COMICS',
    timestamp: Date.now(),
  };
}

function fetchComics() {
  return (dispatch, getState) => {
    const state = getState();
    const { apiUrl } = state.auth;
    const { token } = state.auth;

    dispatch(fetchComicsInProgress());

    return comicsApi.fetchComics(apiUrl, token).then(
      (comics) => {
        dispatch(fetchComicsSuccessful(comics));
        return comics;
      },
      (error) => {
        dispatch(fetchComicsFailed(error));
        throw error;
      },
    );
  };
}

function shouldFetchComics(state, skipOutdatedCheck) {
  const { fetchingInProgressSince, didInvalidate, lastSuccessfulFetch } =
    state.comics;

  if (!fetchingInProgressSince) {
    // Should update if it was explicetely invalidated
    if (didInvalidate) {
      return true;
    }

    // Should update if data is too old
    if (
      !skipOutdatedCheck &&
      (!lastSuccessfulFetch ||
        Date.now() - lastSuccessfulFetch > MIN_COMICS_UPDATE)
    ) {
      return true;
    }
  } else if (
    fetchingInProgressSince &&
    Date.now() - fetchingInProgressSince > FETCH_COMICS_TIMEOUT
  ) {
    // Ensure we cannot get stuck in fetchingInProgressSince=true state.
    return true;
  }

  return false;
}

function fetchComicsIfNeeded() {
  return (dispatch, getState) => {
    if (shouldFetchComics(getState())) {
      return dispatch(fetchComics());
    }
    return Promise.resolve();
  };
}

function readComic(comicId) {
  return (dispatch, getState) => {
    const state = getState();
    const { token } = state.auth;
    const { apiUrl } = state.auth;
    if (!token) {
      return Promise.resolve();
    }
    return comicsApi.readComic(apiUrl, token, comicId).then((result) => {
      if (result && !result.limitExceeded) {
        dispatch(readComicAction(comicId));
      }
      if (result && result.newLootcoinBalance) {
        dispatch(updateLootcoinBalance(result.newLootcoinBalance));
      }
      return result;
    });
  };
}

function readComicManually(comicId, lootcoinBonus = 0) {
  return (dispatch, getState) => {
    const state = getState();
    const { token, user } = state.auth;

    if (!token) {
      return Promise.resolve();
    }

    const { lootcoinBalance } = user?.data || {};

    if (comicId) {
      dispatch(readComicAction(comicId));
    }

    if (
      typeof lootcoinBalance === 'number' &&
      typeof lootcoinBonus === 'number'
    ) {
      dispatch(updateLootcoinBalance(lootcoinBalance + lootcoinBonus));
      return lootcoinBonus;
    }

    return 0;
  };
}

module.exports = {
  fetchComicsIfNeeded,
  fetchComics,
  invalidateComics,
  readComic,
  readComicManually,
  setOrder,
};
